import $ from 'jquery';

/*
elements = {
    selectors: JQuery object
}

currency: string, values: EUR, HRK, DKK, HUF, PLN
*/

function CurrencySelector(elements, currency) {
  this.elements = elements;
  this.currentCurrency = currency;
  this.init();
}

CurrencySelector.prototype = {
  init() {
    const obj = this;

    this.elements.selectors.on('click', function(eventObj) {
      eventObj.preventDefault();
      const currency = $(this).html();
      obj.setCurrency(currency);
    });

    this.elements.mobile_selector.on('change', function() {
      const currency = this.value;
      obj.setCurrency(currency);
    });
  },

  setCurrency(currency) {
    $.ajax({
      url: '/ajax/change_currency/',
      data: {
        currency,
      },
      method: 'post',
      dataType: 'json',
      success: function(response) {
        if (response.reload) {
          this.currentCurrency = currency;
          window.location.reload(true);
        }
      }.bind(this),
    });
  },
};

new CurrencySelector(
  {
    selectors: $('.js-currency-selector a'),
    mobile_selector: $('.js-mobile-currency-selector'),
  },
  document.querySelector('meta[name="globalcurrency"]').getAttribute('content'),
);



// WEBPACK FOOTER //
// ./src/js/currency-selector.js